import React, { useState } from 'react';
import {
  CheckMark,
  Container,
  Card,
  CardTitle,
  LanguageItem,
  LanguageList,
  CardContent,
} from './styles';

interface Props {
  languages: Language[];
  handleLanguageChange: any;
}

interface Language {
  languageId: number;
  name: string;
  pagePrevText: string;
  pageNextText: string;
  completeText: string;
  progressText: string;
  requiredErrorText: string;
  placeholderTextQuestion: string;
  requiredAllrowsErrorText: string;
  value: number;
  label: string;
  languageCode: string;
}

const LanguageSelector: React.FC<Props> = ({
  languages,
  handleLanguageChange,
}) => {
  const [selectedLanguage, setSelectedLanguage] = useState(languages[0]);

  const handleLanguageSelect = (language: Language): void => {
    setSelectedLanguage(language);
    handleLanguageChange(language);
  };

  return (
    <Container>
      {languages && (
        <Card>
          <CardTitle>
            <p style={{ fontSize: '1.5rem' }}>
              Please select your preferred language to start the survey.
            </p>
            <i>
              Bitte wählen Sie Ihre bevorzugte Sprache, um die Umfrage zu
              starten.
            </i>
          </CardTitle>
          <CardContent>
            <LanguageList>
              {languages.map((language: Language) => (
                <LanguageItem
                  key={language.name}
                  $selected={
                    selectedLanguage?.languageId === language.languageId
                  }
                  onClick={() => handleLanguageSelect(language)}
                >
                  {selectedLanguage?.languageId === language.languageId && (
                    <CheckMark>✓</CheckMark>
                  )}
                  {language.name}
                </LanguageItem>
              ))}
            </LanguageList>
          </CardContent>
        </Card>
      )}
    </Container>
  );
};

export default LanguageSelector;
